import React, { useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ButtonPrimary, ButtonSecondary } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import { parseHtml } from '../../utils/util';
import { ChildContext } from '../context';
import { getLookupData } from '../../Methods/Index';

const getVal = require('lodash/get');
/**
 * button component return DLS button to export data
 * @param {*} param0
 */
const ApiButton = ({
  fieldId,
  fieldLabel,
  apiToCall,
  cssProperties,
  filledFormData,
  fieldValidation,
  loggerApiCall,
  downloadedFilename,
  handleContinue,
  nextPage = null,
  curPageValues,
  buttonInfoText,
  infoTexCssProperties,
  shouldSaveCurrentPageValues = false,
}) => {
  const buttonType = 'button';
  const refData = { ...filledFormData };
  const contextVal = useContext(ChildContext);
  const memberApiUrls = useSelector((state) => state.getIn(['config', 'memberApiUrls']));
  const jId = window.sessionStorage.getItem('jId');
  const fileName = downloadedFilename || 'Data.csv';
  const [isDisabled, setIsDisabled] = useState(fieldValidation.disabled);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);
  const [responseCss, setResponseCss] = useState(
    'alert dls-color-warning pad-1-t col-md-12'
  );

  useEffect(() => {
    setIsDisabled(fieldValidation.disabled);
  }, [fieldValidation.disabled]);

  const callApi = async (apiObj) => {
    switch (apiObj.type) {
      case 'getLookupData':
        {
          let payloadBody = {};
          if (apiObj.lookupRequestStaticPayloadParams) {
            payloadBody = { ...apiObj.lookupRequestStaticPayloadParams };
          }
          if (
            apiObj.lookupRequestDynamicPayloadParams
            && apiObj.lookupRequestDynamicPayloadParams.length > 0
          ) {
            apiObj.lookupRequestDynamicPayloadParams.forEach((param) => {
              const val = getVal(refData, param.selectKey);
              payloadBody = { ...payloadBody, [param.addAs]: val };
            });
          }
          let logString = `status=calledGetLookupDataApi type=${apiObj.lookupRequestType} payload=${JSON.stringify(payloadBody)}`;
          loggerApiCall(logString, 'info');
          const apiResponse = await getLookupData({
            type: apiObj.lookupRequestType,
            payloadBody,
            jId,
            memberApiUrls,
            cuid: contextVal.cuid,
          });

          if (apiResponse && apiResponse.statusCode === apiObj.statusCodeMappings.success) {
            setResponseMessage(apiObj.responseMessage.success);
            setResponseCss(apiObj.responseMessage.cssProperties.success);
            const url = window.URL.createObjectURL(new Blob([apiResponse.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${fileName}`);
            // Append to html link element page
            document.body.appendChild(link);
            // Start download
            link.click();
            logString = `status=getLookupDataApiCallSuccess type=${apiObj.lookupRequestType}`;
            loggerApiCall(logString, 'info');
            link.parentNode.removeChild(link);
          } else if (apiResponse && apiResponse.statusCode === apiObj.statusCodeMappings.noData) {
            setResponseMessage(apiObj.responseMessage.noData);
            setResponseCss(apiObj.responseMessage.cssProperties.noData);
          } else {
            setResponseMessage(apiObj.responseMessage.failure);
            setResponseCss(apiObj.responseMessage.cssProperties.failure);
            logString = `status=getLookupDataApiCallFailed type=${apiObj.lookupRequestType}`;
            loggerApiCall(logString, 'error');
          }
          setIsButtonLoading(false);
          setIsDisabled(false);
        }
        break;
      default:
        return true;
    }
    return true;
  };

  const handleOnClick = () => {
    if (apiToCall) {
      setResponseMessage(null);
      setIsButtonLoading(true);
      setIsDisabled(true);
      callApi(apiToCall);
    }
    if (nextPage) {
      /* eslint-disable no-restricted-syntax -- need */
      if (shouldSaveCurrentPageValues) {
        const keys = Object.keys(curPageValues);
        if (keys.length > 0) {
          for (const key of keys) {
            filledFormData[key] = curPageValues[key];
          }
        }
      }
      /* eslint-enable no-restricted-syntax -- need */
      handleContinue(nextPage);
    }
  };

  return (
    <>
      {cssProperties.type && cssProperties.type === 'ButtonSecondary' ? (
        <div className={cssProperties.style}>
          <ButtonSecondary
            size="md"
            id={fieldId}
            type={buttonType}
            className={`${fieldLabel.cssProperties.style} ${fieldId}`}
            disabled={isDisabled}
            loading={isButtonLoading}
            onClick={handleOnClick}
          >
            {parseHtml(fieldLabel.label)}
          </ButtonSecondary>
        </div>
      ) : (
        <div className={cssProperties.style}>
          <ButtonPrimary
            id={fieldId}
            type={buttonType}
            className={`${fieldLabel.cssProperties.style} ${fieldId}`}
            disabled={isDisabled}
            loading={isButtonLoading}
            onClick={handleOnClick}
          >
            {parseHtml(fieldLabel.label)}
          </ButtonPrimary>
          {buttonInfoText && (
            <p className={infoTexCssProperties.style}>{parseHtml(buttonInfoText)}</p>
          )}

        </div>
      )}
      {responseMessage && (
        <div id="responseDiv" className={responseCss}>
          <span>{parseHtml(responseMessage)}</span>
        </div>
      )}
    </>
  );
};

ApiButton.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  fieldId: PropTypes.string,
  downloadedFilename: PropTypes.string,
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  filledFormData: PropTypes.objectOf(PropTypes.shape),
  apiToCall: PropTypes.objectOf(PropTypes.shape),
  loggerApiCall: PropTypes.func,
  handleContinue: PropTypes.func,
  nextPage: PropTypes.string,
  curPageValues: PropTypes.objectOf(PropTypes.shape),
  buttonInfoText: PropTypes.string,
  infoTexCssProperties: PropTypes.objectOf(PropTypes.shape),
  shouldSaveCurrentPageValues: PropTypes.bool,
};

export default ApiButton;
